import React from 'react';
import PropTypes from 'prop-types';
import BellRingOutlineIcon from 'mdi-react/BellRingOutlineIcon';
import MessageTextOutlineIcon from 'mdi-react/MessageTextOutlineIcon';
import AccountMultipleIcon from 'mdi-react/AccountMultipleIcon';
import CalendarClockIcon from 'mdi-react/CalendarClockIcon';
import CellphoneIcon from 'mdi-react/CellphoneIcon';
import TagOutlineIcon from 'mdi-react/TagOutlineIcon';
import ChartBarIcon from 'mdi-react/ChartBarIcon';
import { partial } from '../../../util/translation/translation';
import FeatureShowcase from '../../../shared/components/custom/FeatureShowcase';
import PreviewMessages from './PreviewsMessage';

/**
 * Push and SMS in two steps: write the message (and where a tap on a push
 * leads), then choose who gets it and when, and follow how many open it.
 */
const MessagesShowcase = ({ collapsible, action }) => {
  const s = partial('shared');
  return (
    <FeatureShowcase
      storageKey="messagesShowcaseHidden"
      icon={BellRingOutlineIcon}
      title={s('pushInfoTitle')}
      subtitle={s('pushShowcaseSubtitle')}
      showLabel={s('pushShowcaseShow')}
      uses={[
        {
          key: 'write',
          step: s('showcaseStep', { step: 1 }),
          icon: MessageTextOutlineIcon,
          label: s('pushWriteLabel'),
          text: s('pushWriteText'),
          // The Messages page's phone, with the club's logo
          preview: (
            <PreviewMessages
              formValues={{
                media: 'push',
                heading: s('pushExampleTitle'),
                message: s('pushExampleBody'),
              }}
            />
          ),
        },
        {
          key: 'send',
          step: s('showcaseStep', { step: 2 }),
          icon: AccountMultipleIcon,
          label: s('pushSendLabel'),
          text: s('pushSendText'),
          cards: [
            {
              key: 'audience',
              icon: AccountMultipleIcon,
              title: s('pushCardAudience'),
              text: s('pushCardAudienceText'),
            },
            {
              key: 'time',
              icon: CalendarClockIcon,
              title: s('pushCardTime'),
              text: s('pushCardTimeText'),
            },
            {
              key: 'test',
              icon: CellphoneIcon,
              title: s('pushCardTest'),
              text: s('pushCardTestText'),
            },
            {
              key: 'labels',
              icon: TagOutlineIcon,
              title: s('pushCardLabels'),
              text: s('pushCardLabelsText'),
            },
            {
              key: 'opens',
              icon: ChartBarIcon,
              title: s('pushCardOpens'),
              text: s('pushCardOpensText'),
            },
          ],
        },
      ]}
      sourcesIcon={BellRingOutlineIcon}
      sources={s('pushShowcaseElsewhere')}
      collapsible={collapsible}
      action={action}
    />
  );
};

MessagesShowcase.propTypes = {
  collapsible: PropTypes.bool,
  action: PropTypes.node,
};

MessagesShowcase.defaultProps = {
  collapsible: true,
  action: null,
};

export default MessagesShowcase;
